module.exports = __webpack_public_path__ + "static/img/c101.c5d43cfb.png";